const snackbar = {
  namespaced: true,
  state: {
    snackColor: '',
    snackMessage: ''
  },
  mutations: {
    setSnackColor(state, payload) {
      state.snackColor = payload ?? 'success'
    },
    setSnackMessage(state, payload) {
      state.snackMessage = payload ?? ''
    }
  },
  actions: {
    showSnack(context, payload) {
      context.commit('setSnackColor', payload.color)
      context.commit('setSnackMessage', payload.message)
    }
  },
  getters: {
    getSnackColor(state) {
      return state.snackColor
    },
    getSnackMessage(state) {
      return state.snackMessage
    }
  }
}

export default snackbar
